
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const Navigation = () => (
      <>
        <polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>
      </>
    );
    export default Navigation;
    